import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import { MMTradesEndpointEnum } from "../../../enums/endpoints";
import { MMTRADES_API_URL } from "../../../utils/env";
import { IFormattedInstruments } from "./useOptionsInstruments";

export const useBybitAssets = () => {
  const { tokenId } = useContext(AuthContext);
  const [data, setData] = useState<IFormattedInstruments[] | undefined>(
    undefined
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setData(undefined); // Reset data to undefined when instrument_name changes
    setIsLoading(true);
    const fetchBybitAssets = async () => {
      try {
        const response = await axios.get<any>(
          MMTRADES_API_URL(MMTradesEndpointEnum.BYBIT_ASSETS),
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${tokenId}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        const tradeInstruments = response.data.data ?? [];

        const formattedRows = tradeInstruments.map((item: any) => ({

          InstrumentName: item.Asset,

        }));

        setData(formattedRows as IFormattedInstruments[]);
      } catch (error) {
        // Handle error (optional)
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    if (tokenId) {
      fetchBybitAssets();
    }
  }, [tokenId]);

  return { data, isLoading };
};
